module.exports = __webpack_public_path__ + "en_IE-header-b6012d.webp";